import { IconButton, Typography } from '@material-ui/core';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { FlexContainer } from '../../../../../../layout/Flex';

const ICON_SIZE = 24;
export const CollapsibleSubHeader = ({
  title,
  expanded,
  toggle
}: {
  title: React.ReactNode;
  expanded: boolean;
  toggle: () => void;
}) => {
  return (
    <FlexContainer
      fullWidth
      justifyContent={'flex-start'}
      spacing={1}
      style={{ cursor: 'pointer' }}
      role="button"
      onClick={() => toggle()}
    >
      <Typography variant="h4">{title}</Typography>
      <IconButton>
        {expanded ? (
          <ChevronUp size={ICON_SIZE} />
        ) : (
          <ChevronDown size={ICON_SIZE} />
        )}
      </IconButton>
    </FlexContainer>
  );
};
